var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 16,
  stroke: "var(--hop-neutral-border-weak)",
  strokeWidth: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 4,
  d: "M34 18c0-8.837-7.163-16-16-16"
})));
export default SvgSpinner;